// extracted by mini-css-extract-plugin
module.exports = {"markdown":"markdown-content_markdown__WrZ0L","compact":"markdown-content_compact__Hwb_D","legal":"markdown-content_legal__8abOa"};